import { useEffect } from 'react';

import type { Player } from 'video.js';

export const useHandleSyncPlaybackControls = ({
  videoJs,
  start,
  end,
}: {
  videoJs: Player | null | undefined;
  start: number;
  end?: number;
}) => {
  useEffect(() => {
    if (!videoJs) {
      return;
    }

    const controlBar = videoJs.player_?.getChild('controlBar');

    controlBar?.getChild('clippedCurrentTimeDisplay')?.setStartTime(start);

    const seekBar = controlBar?.getChild('clippedProgressControl')?.getChild('clippedSeekBar');
    seekBar?.setStartTime(start);
    seekBar?.getChild('clippedPlayProgressBar').setStartTime(start);

    const playToggle = controlBar?.getChild('cPlayToggle');
    playToggle?.setStartTime(start);
  }, [videoJs, start]);

  useEffect(() => {
    if (!videoJs || !end) {
      return;
    }
    const controlBar = videoJs.player_?.getChild('controlBar');
    const playToggle = controlBar?.getChild('cPlayToggle');
    playToggle?.setEndTime(end);
  }, [videoJs, end]);
};
